// © Microsoft Corporation. All rights reserved.

import { requireAsync } from "./RequireAsync";

/**
 * Integration function to wait on track extension complete canary.
 *
 * @export
 * @return {Promise<number>} - Resolves if track extension canary is define, rejects otherwise.
 */
export let getTrackExtCompleteCanary: IGetTrackExtComplete = () => {
    return requireAsync<number>("c.trackExtComplete");
};